import { createBrowserHistory } from 'history';
import { getPublicRootUrl } from '../utils/urls';
export const publicBrowserHistory = createBrowserHistory({
  basename: getPublicRootUrl()
});